import { useContext, useEffect, useState } from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import { GatsbyImage } from 'gatsby-plugin-image';
import Cookies from 'universal-cookie';

import GlobalContext from '../../../contexts/globalContext';
import { TabsEnum } from '../../../enums/enums';
import useFullDate from '../../../hooks/useFullDate';
import HomeServices from '../../../services/home-services';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import Breadcrumb from '../../atoms/breadcrumb/breadcrumb';
import Button from '../../atoms/button/button';
import GenericToast from '../../atoms/generic-toast/genericToast';
import Loader from '../../atoms/loader/loader';
import PaymentStepper from '../../molecules/payment-stepper/payment-stepper';
import WeSorry from '../we-sorry/we-sorry';
import './confirmationPayment.scss';
import { getAssetUrl } from '@/utils/contentFullAsset';

const ConfirmationPayment = () => {
  const data = useStaticQuery(graphql`
    query GET_PORTAL_SERVICIOS_PASO3_1 {
      allContentfulTemplate(filter: { titulo: { eq: "pagos personas privado > Paso 3-1" } }) {
        nodes {
          referencias {
            ... on ContentfulTemplate {
              titulo
              migaDePan
              lista
              imagen {
                title
                file {
                  url
                }
                gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
              }
              nombre
              subtitulo
              referencias {
                ... on ContentfulTemplate {
                  lista
                  copyBoton
                  redireccion
                }
              }
            }
          }
        }
      }
    }
  `);

  const { gigyaContext, userInfoContext, selectedTab } = useContext(GlobalContext);
  const [paymentStatus, setPaymentStatus] = useState<any>(null);
  const [contentIndex, setcontentIndex] = useState(0);
  const [thereIsAnError, setThereIsAnError] = useState(false);
  const [loader, setLoader] = useState(true);
  const [isPending, setIsPending] = useState(false);
  const [activeToast, setActiveToast] = useState<any>(null);
  const { window } = useBrowserMode();

  const allContent = data.allContentfulTemplate.nodes[0].referencias;

  const getStatusIndex = (status) => {
    switch (status) {
      case 'APPROVED':
        return 0;

      case 'REJECTED':
        return 1;

      default:
        return 2;
    }
  };
  const getFinishButtonIndex = (status) => {
    switch (status) {
      case 'APPROVED':
        return 3;

      case 'REJECTED':
        return 2;

      default:
        return 3;
    }
  };

  const getTransacctionResult = async () => {
    const cookies = new Cookies();
    const transactionData = cookies.get('transactionData');
    if (transactionData && !paymentStatus) {
      const decripted = JSON.parse(atob(transactionData));

      const payload = `/${decripted.requestId}`;
      try {
        const data = await HomeServices.checkPaymentPlaceToPay(payload);
        if (data.status === 200) {
          if (data.data.comprobanteB64 !== '' && data.data.payment.length > 0) {
            const paymentData = {
              dbReference: data.data.reference,
              receipt: data.data.payment?.[0]?.receipt,
              value: data.data.payment?.[0]?.amount.to.total,
              cus: data.data.payment?.[0]?.authorization,
              method: data.data.payment?.[0]?.paymentMethodName,
              payments: data.data.request.payments,
              status: data.data.status.status,
              date: data.data.status.dateFormatted
                ? `${useFullDate(data.data.status.dateFormatted.split(' ')[0])} ${
                    data.data.status.dateFormatted.split(' ')[1]
                  } ${data.data.status.dateFormatted.split(' ')[2]}`
                : '-',
              base64: data.data.comprobanteB64,
            };
            setIsPending(paymentData.status !== 'APPROVED' && paymentData.status !== 'REJECTED');
            if (paymentData.status === 'APPROVED') {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'pushEventGA',
                category: 'HomePersonas',
                action: 'ClicPagoCredito',
                label: 'PagoExitoso',
              });
            }
            setLoader(false);
            setcontentIndex(getStatusIndex(paymentData.status));
            setPaymentStatus(paymentData);
          } else if (data.data.comprobanteB64 === '') {
            if (data.data.status.status === 'PENDING') {
              const paymentData = {
                dbReference: data.data.reference,
                receipt: data.data.payment?.[0]?.receipt,
                value: data.data.payment?.[0]?.amount.to.total,
                cus: data.data.payment?.[0]?.authorization,
                method: data.data.payment?.[0]?.paymentMethodName,
                payments: data.data.request.payments,
                status: data.data.status.status,
                date: data.data.status.dateFormatted
                  ? `${useFullDate(data.data.status.dateFormatted.split(' ')[0])} ${
                      data.data.status.dateFormatted.split(' ')[1]
                    } ${data.data.status.dateFormatted.split(' ')[2]}`
                  : '-',
                base64: data.data.comprobanteB64,
              };
              setIsPending(true);
              setLoader(false);
              setcontentIndex(getStatusIndex(paymentData.status));
              setPaymentStatus(paymentData);
            } else {
              window.location.href =
                window.location.origin +
                (window?.location.hostname === 'localhost'
                  ? '/personas/pagos'
                  : '/portal-servicios/personas/pagos');
            }
          }
        } else {
          setLoader(false);
          setThereIsAnError(true);
        }
      } catch (error) {
        console.log(error);
        setLoader(false);
      } finally {
        cookies.remove('transactionData', { path: '/' });
      }
    }
  };

  useEffect(() => {
    getTransacctionResult();
  }, []);

  const getStatusClass = (status) => {
    switch (status) {
      case 0:
        return ' --ok';

      case 1:
        return ' --failed';

      default:
        return ' --pending';
    }
  };

  const formatCurrency = (number) => {
    return (
      new Intl.NumberFormat('es-ES').format(number) +
      (Number.isInteger(parseFloat(number)) ? ',00' : '')
    );
  };

  useEffect(() => {
    const checkThereIsInfo = setTimeout(() => {
      if (
        !(gigyaContext && userInfoContext && userInfoContext.data?.userJwt) &&
        !paymentStatus &&
        !contentIndex.toString()
      ) {
        console.log('error checkThereIsInfo');
        setLoader(false);
        setThereIsAnError(true);
      }
    }, 5000);

    return () => {
      clearTimeout(checkThereIsInfo);
    };
  }, []);

  useEffect(() => {
    const checkPending = setTimeout(() => {
      if (
        isPending ||
        (paymentStatus &&
          paymentStatus.status !== 'APPROVED' &&
          paymentStatus.status !== 'REJECTED')
      ) {
        location.reload();
      }
    }, 45000);

    return () => {
      clearTimeout(checkPending);
    };
  }, [paymentStatus]);

  const downloadCertificate = (base64, selectedFileName) => {
    const byteCharacters = atob(base64);

    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    try {
      const file = new Blob([byteArray], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(file);
      const fileName = selectedFileName;
      link.download = fileName;
      link.click();
      setActiveToast &&
        setActiveToast(
          <GenericToast
            setActiveToast={setActiveToast}
            isOk
            message="¡Tu certificado ha sido descargado con éxito!"
            position="down-right"
            duration={4000}
          />,
        );
    } catch (e) {
      console.error(e);
      setActiveToast &&
        setActiveToast(
          <GenericToast
            setActiveToast={setActiveToast}
            isOk={false}
            message="Lo sentimos, no fue posible descargar el certificado"
            position="down-right"
            duration={4000}
          />,
        );
    }
  };
  return (
    <div className={`o-confirmation-payment ${loader ? ' --while-loading' : ''}`}>
      {activeToast && <>{activeToast}</>}
      {!loader ? (
        !thereIsAnError && contentIndex.toString() && paymentStatus ? (
          <>
            <div className="o-confirmation-payment-breadcrumb">
              <Breadcrumb content={allContent[contentIndex].migaDePan} />
            </div>
            {allContent[contentIndex]?.lista?.length > 0 && (
              <PaymentStepper itemList={allContent[contentIndex].lista} currentIndex={2} />
            )}

            {allContent[contentIndex].imagen &&
            allContent[contentIndex].imagen[0] &&
            allContent[contentIndex].imagen[0].gatsbyImage ? (
              <GatsbyImage
                loading="eager"
                image={allContent[contentIndex].imagen[0].gatsbyImage}
                alt={allContent[contentIndex].imagen[0].title}
                title={allContent[contentIndex].imagen[0].title}
                className="o-confirmation-payment-img"
              />
            ) : (
              allContent[contentIndex].imagen[0].file &&
              allContent[contentIndex].imagen[0].file.url && (
                <img
                  src={getAssetUrl(allContent[contentIndex].imagen[0])}
                  alt={allContent[contentIndex].imagen[0].title}
                  title={allContent[contentIndex].imagen[0].title}
                  className="o-confirmation-payment-img"
                />
              )
            )}
            <h1 className={`o-confirmation-payment-title ${getStatusClass(contentIndex)}`}>
              {allContent[contentIndex].nombre}
            </h1>
            <div className="o-confirmation-payment-card">
              {paymentStatus.payments && paymentStatus.payments.length > 1 ? (
                // multiple payments ----------------------------
                <div className="o-confirmation-payment-card-list">
                  <div className="o-confirmation-payment-card-list__row">
                    {allContent[contentIndex].referencias[0] &&
                      allContent[contentIndex].referencias[0].lista[0] && (
                        <h3 className="o-confirmation-payment-card-list__row-title">
                          {allContent[contentIndex].referencias[0].lista[0] ?? ' Valor'}
                        </h3>
                      )}
                    <p className="o-confirmation-payment-card-list__row-value">
                      {`$${formatCurrency(paymentStatus.value)}`}
                    </p>
                  </div>
                  {contentIndex !== 1 && (
                    <div className="o-confirmation-payment-card-list__row">
                      {allContent[contentIndex].referencias[0] &&
                        allContent[contentIndex].referencias[0].lista[1] && (
                          <h3 className="o-confirmation-payment-card-list__row-title">
                            {allContent[contentIndex].referencias[0].lista[1] ?? ' Banco'}
                          </h3>
                        )}
                      <p className="o-confirmation-payment-card-list__row-value">
                        {paymentStatus.method ?? '-'}
                      </p>
                    </div>
                  )}
                  <div className="o-confirmation-payment-card-list__row">
                    {allContent[contentIndex].referencias[0] &&
                      allContent[contentIndex].referencias[0].lista[contentIndex !== 1 ? 2 : 1] && (
                        <h3 className="o-confirmation-payment-card-list__row-title">
                          {allContent[contentIndex].referencias[0].lista[
                            contentIndex !== 1 ? 2 : 1
                          ] ?? ' Referencia de trasacción'}
                        </h3>
                      )}
                    <p className="o-confirmation-payment-card-list__row-value">
                      {paymentStatus.dbReference ?? '-'}
                    </p>
                  </div>
                  <div className="o-confirmation-payment-card-list__row">
                    {allContent[contentIndex].referencias[0] &&
                      allContent[contentIndex].referencias[0].lista[contentIndex !== 1 ? 3 : 2] && (
                        <h3 className="o-confirmation-payment-card-list__row-title">
                          {allContent[contentIndex].referencias[0].lista[
                            contentIndex !== 1 ? 3 : 2
                          ] ?? ' Referencia y descripción'}
                        </h3>
                      )}
                    <div className="o-confirmation-payment-card-list__row-values">
                      {paymentStatus.payments?.map((value, index) => {
                        return (
                          <p
                            className="o-confirmation-payment-card-list__row-value"
                            key={`o-confirmation-payment-card-list__row-value-${index}`}
                          >
                            {value.reference}
                            <span>{value.description ?? '-'}</span>
                          </p>
                        );
                      })}
                    </div>
                  </div>
                  {contentIndex !== 1 && (
                    <div className="o-confirmation-payment-card-list__row">
                      {allContent[contentIndex].referencias[0] &&
                        allContent[contentIndex].referencias[0].lista[4] && (
                          <h3 className="o-confirmation-payment-card-list__row-title">
                            {allContent[contentIndex].referencias[0].lista[4] ??
                              ' Autorización CUS'}
                          </h3>
                        )}
                      <p className="o-confirmation-payment-card-list__row-value">
                        {paymentStatus.cus ?? '-'}
                      </p>
                    </div>
                  )}
                  <div className="o-confirmation-payment-card-list__row">
                    {allContent[contentIndex].referencias[0] &&
                      allContent[contentIndex].referencias[0].lista[contentIndex !== 1 ? 5 : 3] && (
                        <h3 className="o-confirmation-payment-card-list__row-title">
                          {allContent[contentIndex].referencias[0].lista[
                            contentIndex !== 1 ? 5 : 3
                          ] ?? ' Fecha y hora'}
                        </h3>
                      )}
                    <p className="o-confirmation-payment-card-list__row-value">
                      {paymentStatus.date ?? '-'}
                    </p>
                  </div>
                </div>
              ) : (
                // single payment ------------------------
                <div className="o-confirmation-payment-card-list">
                  <div className="o-confirmation-payment-card-list__row">
                    {allContent[contentIndex].referencias[1] &&
                      allContent[contentIndex].referencias[1].lista[0] && (
                        <h3 className="o-confirmation-payment-card-list__row-title">
                          {allContent[contentIndex].referencias[1].lista[0] ?? ' Valor'}
                        </h3>
                      )}
                    <p className="o-confirmation-payment-card-list__row-value">
                      {`$${formatCurrency(paymentStatus.value)}`}
                    </p>
                  </div>
                  {contentIndex !== 1 && (
                    <div className="o-confirmation-payment-card-list__row">
                      {allContent[contentIndex].referencias[1] &&
                        allContent[contentIndex].referencias[1].lista[1] && (
                          <h3 className="o-confirmation-payment-card-list__row-title">
                            {allContent[contentIndex].referencias[1].lista[1] ?? ' Banco'}
                          </h3>
                        )}
                      <p className="o-confirmation-payment-card-list__row-value">
                        {paymentStatus.method ?? '-'}
                      </p>
                    </div>
                  )}
                  <div className="o-confirmation-payment-card-list__row">
                    {allContent[contentIndex].referencias[1] &&
                      allContent[contentIndex].referencias[1].lista[contentIndex !== 1 ? 2 : 1] && (
                        <h3 className="o-confirmation-payment-card-list__row-title">
                          {allContent[contentIndex].referencias[1].lista[
                            contentIndex !== 1 ? 2 : 1
                          ] ?? ' Referencia transaccion'}
                        </h3>
                      )}
                    <p className="o-confirmation-payment-card-list__row-value">
                      {paymentStatus.dbReference ?? '-'}
                    </p>
                  </div>
                  <div className="o-confirmation-payment-card-list__row">
                    {allContent[contentIndex].referencias[1] &&
                      allContent[contentIndex].referencias[1].lista[contentIndex !== 1 ? 3 : 2] && (
                        <h3 className="o-confirmation-payment-card-list__row-title">
                          {allContent[contentIndex].referencias[1].lista[
                            contentIndex !== 1 ? 3 : 2
                          ] ?? ' Referencia pago'}
                        </h3>
                      )}
                    <p className="o-confirmation-payment-card-list__row-value">
                      {paymentStatus.payments[0].reference ?? '-'}
                    </p>
                  </div>
                  <div className="o-confirmation-payment-card-list__row">
                    {allContent[contentIndex].referencias[1] &&
                      allContent[contentIndex].referencias[1].lista[contentIndex !== 1 ? 4 : 3] && (
                        <h3 className="o-confirmation-payment-card-list__row-title">
                          {allContent[contentIndex].referencias[1].lista[
                            contentIndex !== 1 ? 4 : 3
                          ] ?? ' Descripción'}
                        </h3>
                      )}
                    <p className="o-confirmation-payment-card-list__row-value">
                      {paymentStatus.payments[0].description ?? '-'}
                    </p>
                  </div>
                  {contentIndex !== 1 && (
                    <div className="o-confirmation-payment-card-list__row">
                      {allContent[contentIndex].referencias[1] &&
                        allContent[contentIndex].referencias[1].lista[5] && (
                          <h3 className="o-confirmation-payment-card-list__row-title">
                            {allContent[contentIndex].referencias[1].lista[5] ??
                              ' Autorización CUS'}
                          </h3>
                        )}
                      <p className="o-confirmation-payment-card-list__row-value">
                        {paymentStatus.cus ?? '-'}
                      </p>
                    </div>
                  )}
                  <div className="o-confirmation-payment-card-list__row">
                    {allContent[contentIndex].referencias[1] &&
                      allContent[contentIndex].referencias[1].lista[contentIndex !== 1 ? 6 : 4] && (
                        <h3 className="o-confirmation-payment-card-list__row-title">
                          {allContent[contentIndex].referencias[1].lista[
                            contentIndex !== 1 ? 6 : 4
                          ] ?? ' Fecha y hora'}
                        </h3>
                      )}
                    <p className="o-confirmation-payment-card-list__row-value">
                      {paymentStatus.date ?? '-'}
                    </p>
                  </div>
                </div>
              )}
              {/* buttons --------------------------------- */}
              {(paymentStatus.status === 'APPROVED' || paymentStatus.status === 'REJECTED') &&
                paymentStatus.base64 &&
                paymentStatus.base64 !== '' && (
                  <Button
                    type="button"
                    classname="o-confirmation-payment-card__dowloand secondary"
                    text="DESCARGAR COMPROBANTE"
                    isDisabled={false}
                    onClickAction={() => {
                      downloadCertificate(paymentStatus.base64, 'Comprobante');
                    }}
                    loader={false}
                  />
                )}
              {allContent[contentIndex]?.referencias[getFinishButtonIndex(paymentStatus.status)]
                ?.copyBoton && (
                <Button
                  type="button"
                  classname="o-confirmation-payment-card__buttonFinish primary"
                  text={
                    allContent[contentIndex]?.referencias[
                      getFinishButtonIndex(paymentStatus.status)
                    ].copyBoton
                  }
                  isDisabled={false}
                  onClickAction={() => {
                    selectedTab?.get === TabsEnum.BUSINESS
                      ? (location.href =
                          window?.location.hostname === 'localhost'
                            ? '/empresas/pagos'
                            : '/portal-servicios/empresas/pagos')
                      : (location.href =
                          window?.location.hostname === 'localhost'
                            ? '/personas/pagos'
                            : '/portal-servicios/personas/pagos');
                  }}
                  loader={false}
                />
              )}
            </div>
          </>
        ) : (
          <WeSorry />
        )
      ) : (
        <Loader size="__big" />
      )}
    </div>
  );
};

export default ConfirmationPayment;
